// Parrainage entre clubs (D-087) : le lien du club et le message tout prêt à envoyer à un autre club.
// Le lien court arceau.app/r/<code> renvoie vers la page de vente avec ?r=<code> (Caddy).

export const SITE = 'https://arceau.app';
export const REFERRAL_RATE = 0.1;
export const REFERRED_TRIAL_DAYS = 60;

export const referralUrl = (code: string): string => `${SITE}/r/${code}`;
/** Le lien au bas des pré-demandes de dérogation : celui du club demandeur s'il en a un. */
export const derogationSiteUrl = (code: string | null | undefined): string =>
  code ? `${SITE}/?r=${encodeURIComponent(code)}&depuis=derogation` : `${SITE}/?depuis=derogation`;

/** « Au BC Rivebelle », « À l’Union sportive… » */
const atClub = (name: string) => (/^[aeiouyhàâéèêëîïôöûü]/i.test(name.trim()) ? `À l’${name.trim()}` : `Au ${name.trim()}`);

/** Le message que le bureau envoie à un autre club (modifiable avant l'envoi). */
export function referralMessage(clubName: string, code: string): string {
  return [
    'Bonjour,',
    `${atClub(clubName)}, on gère le club avec Arceau : convocations, présences, licences, partenaires, tout au même endroit, sur le téléphone.`,
    `Avec ce lien, votre club a ${REFERRED_TRIAL_DAYS} jours d’essai gratuit au lieu de 30 :`,
    referralUrl(code),
  ].join('\n');
}

/** Bon de 10 % de ce que le filleul a payé (TTC, centimes). */
export const voucherFor = (paidCents: number): number => Math.round(paidCents * REFERRAL_RATE);
